module.exports = __webpack_public_path__ + "static/media/slide5.f332f668.jpg";